import { VendorGetUseCase } from '../../../../application';

export default class VendorSaveService {

    async execute(event) {
        const data = await VendorGetUseCase(event);
        return data;
    }
}
